import React, { Component } from 'react';
import {ContentDiv, BodyHeaderDiv, BodyHeaderText, SubmitBtn, MidCifBtn} from '../../theme/MorsTheme';
import {Row,Col,Form, Modal} from 'react-bootstrap';

export default class bizCardOnlineContact extends Component {

render() {

    return (
    <div>
		<BodyHeaderDiv>
			<BodyHeaderText>Contact Us</BodyHeaderText>
	    </BodyHeaderDiv>
        
        <ContentDiv>
		<Row class="col-md-12 col-sm-12 contentcontainer">
			<div class="col-md-2"></div >
			<div class="col-md-8 col-sm-12"><br />BDO CLG Corporate Card Sales: 7026000 LOC 58179<br /><br /></div>	
		</Row>
        </ContentDiv>
    </div>
    );
}
}